// extracted by mini-css-extract-plugin
module.exports = {"image":"SetupCard_image__14_u4","card":"SetupCard_card__2gMaw","card-active":"SetupCard_card-active__2A1K7","content":"SetupCard_content__1M4CC"};